import { createSelector } from 'reselect'
import { RootState } from 'redux/root-reducer'

const selectSearch = (state: RootState) => state.search

export const selectFoundWord = createSelector(
  [selectSearch],
  (search) => search.foundWord
)
